<template>
  <div class="flex">
    <svg v-if="!notificationOn" class="w-6 cursor-pointer" @click="toggleAlert" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <g>
      <g>
        <rect x="122.435" y="66.783" width="33.391" height="33.391"/>
      </g>
    </g>
    <g>
      <g>
        <rect x="155.826" y="33.391" width="33.391" height="33.391"/>
      </g>
    </g>
    <g>
      <g>
        <polygon points="422.957,345.043 422.957,100.174 389.565,100.174 389.565,345.043 122.435,345.043 122.435,100.174 
          89.044,100.174 89.044,345.043 66.783,345.043 66.783,378.435 445.217,378.435 445.217,345.043 		"/>
      </g>
    </g>
    <g>
      <g>
        <rect x="200.348" y="478.609" width="111.304" height="33.391"/>
      </g>
    </g>
    <g>
      <g>
        <rect x="189.217" width="133.565" height="33.391"/>
      </g>
    </g>
    <g>
      <g>
        <rect x="356.174" y="66.783" width="33.391" height="33.391"/>
      </g>
    </g>
    <g>
      <g>
        <rect x="322.783" y="33.391" width="33.391" height="33.391"/>
      </g>
    </g>
    <g>
      <g>
        <polygon points="445.217,378.435 445.217,411.826 66.783,411.826 66.783,378.435 33.391,378.435 33.391,445.217 166.957,445.217 
          166.957,478.609 200.348,478.609 200.348,445.217 311.652,445.217 311.652,478.609 345.043,478.609 345.043,445.217 
          478.609,445.217 478.609,378.435 		"/>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>

    <svg class="w-6 cursor-pointer" v-else @click="toggleAlert" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <polygon style="fill:#FFDE46;" points="445.217,378.435 445.217,345.043 422.957,345.043 422.957,100.174 389.565,100.174 
      389.565,66.783 356.174,66.783 356.174,33.391 322.783,33.391 322.783,0 189.217,0 189.217,33.391 155.826,33.391 155.826,66.783 
      122.435,66.783 122.435,100.174 89.043,100.174 89.043,345.043 66.783,345.043 66.783,378.435 33.391,378.435 33.391,445.217 
      166.957,445.217 166.957,478.609 200.348,478.609 200.348,512 311.652,512 311.652,478.609 345.043,478.609 345.043,445.217 
      478.609,445.217 478.609,378.435 "/>
    <polygon style="fill:#FFAE37;" points="445.217,378.435 445.217,345.043 422.957,345.043 422.957,311.652 89.043,311.652 
      89.043,345.043 66.783,345.043 66.783,378.435 33.391,378.435 33.391,445.217 478.609,445.217 478.609,378.435 "/>
    <g>
      <polygon style="fill:#FFFFFF;" points="189.217,22.261 189.217,33.391 178.087,33.391 155.826,33.391 155.826,55.652 
        155.826,66.783 144.696,66.783 122.435,66.783 122.435,100.174 89.043,100.174 89.043,345.043 144.696,345.043 144.696,100.174 
        155.826,100.174 155.826,89.043 178.087,89.043 178.087,66.783 189.217,66.783 189.217,55.652 211.478,55.652 211.478,33.391 
        211.478,22.261 	"/>
      <polygon style="fill:#FFFFFF;" points="66.783,367.304 66.783,378.435 55.652,378.435 33.391,378.435 33.391,445.217 
        89.043,445.217 89.043,422.957 89.043,389.565 89.043,378.435 89.043,367.304 89.043,345.043 66.783,345.043 	"/>
      <polygon style="fill:#FFFFFF;" points="189.217,434.087 166.957,434.087 166.957,478.609 189.217,478.609 200.348,478.609 
        200.348,489.739 200.348,512 222.609,512 222.609,489.739 222.609,478.609 222.609,467.478 222.609,434.087 	"/>
    </g>
    <rect x="122.435" y="66.783" width="33.391" height="33.391"/>
    <rect x="155.826" y="33.391" width="33.391" height="33.391"/>
    <polygon points="445.217,378.435 445.217,345.043 422.957,345.043 422.957,100.174 389.565,100.174 389.565,345.043 
      122.435,345.043 122.435,100.174 89.043,100.174 89.043,345.043 66.783,345.043 66.783,378.435 "/>
    <rect x="200.348" y="478.609" width="111.304" height="33.391"/>
    <rect x="189.217" width="133.565" height="33.391"/>
    <rect x="356.174" y="66.783" width="33.391" height="33.391"/>
    <rect x="322.783" y="33.391" width="33.391" height="33.391"/>
    <polygon points="445.217,378.435 445.217,411.826 66.783,411.826 66.783,378.435 33.391,378.435 33.391,445.217 166.957,445.217 
      166.957,478.609 200.348,478.609 200.348,445.217 311.652,445.217 311.652,478.609 345.043,478.609 345.043,445.217 
      478.609,445.217 478.609,378.435 "/>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>
    <button @click="toggleAlert" class="font-thin text-xs cursor-pointer self-end bg-white p-1 rounded-md m-1 bg-blue-400 text-white shadow">Get price alerts</button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CryptoCardControls",
  props: {
    id: Number,
    notificationOn: Boolean,
  },
  methods: {
    toggleAlert() {
      if (!this.isLoggedIn) {
        this.$router.push({ name: 'auth' })
      } else {
        this.$emit('notification-click')
      }
    },
    async logout() {
      await this.$auth.signOut()
    },
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'firebaseUid'])
  },
};
</script>